import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['scroll'];

    scrollTargetConnected(target) {
        const checkScrollPos = (function checkScrollPos(target, element) {
            if (target.scrollTop >= (target.scrollHeight - target.offsetHeight - 2)) {
                element.classList.remove('can-scroll-down');
            } else {
                element.classList.add('can-scroll-down');
            }

            return checkScrollPos;
        })(target, this.element);

        target.addEventListener('scroll', () => { checkScrollPos(target, this.element) });
    }
}
